import React, { useRef, useState } from 'react';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import useGetTreelistData from './useGetTreelistData';

import { IWidget } from '../../../types/IWidget';

import { TreeList, TreeListSortChangeEvent, treeToFlat } from '@progress/kendo-react-treelist';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import SwitchButtons from '../../../../ui/button/switchButtons/switchButtons';
import WidgetTitle from '../widgetTitle/widgetTitle';
import TableLoading from '../../../../ui/loaders/tableLoader/tableLoading';
import OutletLoader from '../../../../ui/loaders/outletLoader/outletLoader';

import './treeListWidget.scss';

const subItemsField = 'childNodes';
const expandField = 'expanded';

const TreeListWidget: React.FC<IWidget> = ({
                                             setup,
                                             widget,
                                             measures,
                                             scenarios,
                                             onExpand,
                                             onCollapse,
                                             expand,
                                             notes,
                                             boardId,
                                             id,
                                             handleWidgetChange,
                                             widgets,
                                             changeOldIndex,
                                             handleWidgetMove,
                                             changeNewIndex,
                                             customisation,
                                             selectedPeriod,
                                             selectedObject,
                                             boardSelectedCurrency,
                                             investorObjectId,
                                             homePage,
                                             handleUnpin,
                                             handlePinWidget,
                                             handleUnpinWidget,
                                             unpinId,
                                           }) => {
  const [sort, setSort] = useState<SortDescriptor[]>([{ field: 'name', dir: 'asc' }]);

  const tableRef = useRef(null);

  const {
    sectionsForGrid,
    treelistContentEnriched,
    onExpandChange,
    loading,
    treelistNotes,
    selectTreeListSection,
    processData,
    totalWidth,
    currencies,
    selectedCurrency,
    handleCurrencyChange,
  } = useGetTreelistData(
    setup,
    widget,
    measures,
    notes,
    boardId,
    scenarios,
    selectedObject,
    selectedPeriod,
    boardSelectedCurrency,
    investorObjectId,
  );

  let exportItem;

  const exportToExcel = (): void => {
    exportItem.save(treeToFlat(processData(), expandField, subItemsField), treelistContentEnriched);
  };

  return loading ? (
    <OutletLoader />
  ) : (
    <>
      <WidgetTitle
        onClick={exportToExcel}
        name={widget.name}
        type={widget.type}
        selectedCurrency={selectedCurrency}
        currencySelection={(widget.pinned === null || widget.setup.currencySelection) ? currencies : false}
        handleCurrencyChange={handleCurrencyChange}
        onExpand={onExpand}
        onCollapse={onCollapse}
        expand={expand}
        notes={treelistNotes}
        id={id}
        customisation={customisation}
        widgets={widgets}
        handleWidgetChange={handleWidgetChange}
        handleWidgetMove={handleWidgetMove}
        changeNewIndex={changeNewIndex}
        changeOldIndex={changeOldIndex}
        widget={widget}
        selectedObject={selectedObject}
        homePage={homePage}
        investorId={investorObjectId}
        handleUnpin={handleUnpin}
        handlePinWidget={handlePinWidget}
        handleUnpinWidget={handleUnpinWidget}
        unpinId={unpinId}
      />
      <div className='treelist-widget-table'>
        <SwitchButtons buttons={sectionsForGrid} onClick={selectTreeListSection} />
        <div className='treelist-widget-table-wrapper'>
          <ExcelExport ref={(exporter) => (exportItem = exporter)} hierarchy={true}>
            <TreeList
              expandField={expandField}
              subItemsField={subItemsField}
              ref={tableRef}
              onExpandChange={onExpandChange}
              data={orderBy(processData(), sort)}
              scrollable={'scrollable'}
              sortable={true}
              sort={sort}
              tableProps={{ style: { width: totalWidth } }}
              onSortChange={(sortEvent: TreeListSortChangeEvent) => {
                setSort(sortEvent.sort);
              }}
              columns={treelistContentEnriched}
            />
            {loading && <TableLoading tableElement={tableRef} />}
          </ExcelExport>
        </div>
      </div>
    </>
  );
};

export default TreeListWidget;
